import { RegSettingDetail } from 'src/settings/models/regSetting';
import AxiosInstance from './axios/interceptor';

const controller = 'RegSetting';

export const getMainSettings = () => {
  return AxiosInstance.get<RegSettingDetail[]>(`${controller}/Main`);
};

export const updateMainSettings = (data: RegSettingDetail[]) => {
  return AxiosInstance.put(`${controller}/Main`, data);
};
